<div class="content">

  <div class="item-list" *ngFor="let inscricao of inscricoes">
    <span (click)="find(inscricao.id)" style="cursor: pointer;">
      {{inscricao.candidato.nomeCompleto}}, inscrição {{inscricao.id}}, enviou nova documentação.
    </span>
  </div>

</div>